import {loading, stopLoading} from "../../helpers/loading";
import Axios from "axios";
import handleAjaxError from "../../helpers/handleAjaxError";
import {handleAjaxSuccess} from "../../helpers/swalHelper";

function initPublicConfimSubmissionIndex() {

	// Setup submit button
	const submitButton = document.querySelector('.continue-button')
	submitButton.addEventListener('click', handleContinueRequest)

	/** Methods */

	function handleContinueRequest() {
		loading();

		Axios.post(submitButton.dataset.route)
			.then(handleAjaxSuccess)
			.catch(handleAjaxError)
			.finally(stopLoading)

	}
}

export {
	initPublicConfimSubmissionIndex
}
